module.exports = __webpack_public_path__ + "img/stores_legal@1x.f6b3409.webp";